import { render, staticRenderFns } from "./SnsIconContent.vue?vue&type=template&id=047d0fbd&scoped=true&"
import script from "./SnsIconContent.vue?vue&type=script&lang=js&"
export * from "./SnsIconContent.vue?vue&type=script&lang=js&"
import style0 from "./SnsIconContent.vue?vue&type=style&index=0&id=047d0fbd&lang=scss&scoped=true&"
import style1 from "./SnsIconContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d0fbd",
  null
  
)

export default component.exports